
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/kyc",
      function () {
        return require("private-next-pages/user/kyc/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/kyc"])
      });
    }
  